import posthog from 'posthog-js'

function initializePostHog() {
  if (window.posthogInitialized) {
    return
  }

  if (!gon.global.posthog_api_key) {
    return
  }

  posthog.init(gon.global.posthog_api_key, {
    api_host: 'https://us.i.posthog.com',
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    session_recording: {
      maskAllInputs: false,
      person_profiles: 'always',
      maskInputOptions: {
        password: true
      }
    },
    loaded: function(posthog) {
      if (gon.current_user) {
        posthog.identify(gon.current_user.id, {
          email: gon.current_user.email,
          name: gon.current_user.name,
          user_id: gon.current_user.id
        });
      }
    }
  });

  setupPageviewTracking()
  window.posthogInitialized = true
}

function setupPageviewTracking() {
  document.addEventListener("turbo:load", function(event) {
    if (!posthog) return

    posthog.capture('$pageview', { url: event.detail.url })
  })
}

initializePostHog()

export default posthog